import FormatMoney from '@/common/format-money'
import processImage from '@leafiy/process-image'
import Axios from 'axios'
import {
  Collapse,
  CollapseItem,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Icon,
  Loading,
  MessageBox,
  Pagination,
  Popover,
  Rate,
  Slider,
  Switch,
} from 'element-ui'
import Vue from 'vue'
import VueCurrencyFilter from 'vue-currency-filter'
import VueLazyload from 'vue-lazyload'
import VueYoutube from 'vue-youtube'
// import infiniteScroll from 'vue-infinite-scroll'
import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App.vue'
import './assets/iconfont/iconfont'
import './assets/iconfont/iconfont.css'
import CONFIG from './common/config'
import FontIcon from './components/FontIcon.vue'
import i18n from './lang/index'
import router from './router'
import store from './store/index'
const uuidv1 = require('uuid/v1')

Vue.config.productionTip = false

let userId = localStorage.getItem('jodi-user-id')
if (!userId) {
  userId = uuidv1()
  localStorage.setItem('jodi-user-id', userId)
}

Axios.defaults.headers.common['userId'] = userId
Axios.defaults.headers.common['companyId'] = 'kx~jodi'
Axios.defaults.headers.common['shopId'] = 'kx~shop~jodi'
Axios.defaults.baseURL = CONFIG.API_HOST
Axios.interceptors.request.use(
  function(config) {
    // do something
    return config
  },
  function(error) {
    // do something
    return Promise.reject(error)
  }
)

Axios.interceptors.response.use(
  function(response) {
    // do something
    const res = response.data
    return res
  },
  function(error) {
    // do something
    return Promise.reject(error)
  }
)
Vue.prototype.$axios = Axios

// 按需引入
Vue.use(Slider)
Vue.use(Loading)
Vue.use(Rate)
Vue.use(Pagination)
Vue.use(Switch)
Vue.use(Popover)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Icon)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)

// Vue.use(infiniteScroll)
Vue.use(VueGoogleMaps, {
  load: {
    key: CONFIG.GOOGLE_MAP_KEY,
    libraries: 'places',
  },
  installComponents: true,
})
Vue.use(VueLazyload, { loading: require('./assets/images/loading.gif') })
Vue.use(VueCurrencyFilter)
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$processImage = processImage
Vue.prototype.$formatMoney = FormatMoney

Vue.component('FontIcon', FontIcon)
Vue.use(VueYoutube)

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
